"use client";
import Image from "next/image";
import styles from "./ScholarshipOffers.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import ArrowRight from "@/SvgIcons/ArrowRight";
import { StorageService } from "@/helpers/storage.service";

/*. Statics Content End */
interface Scholarship {
  id: number;
  scholarship_name: string;
  description: string;
  discount_percentage: string;
  category_id: number;
  list: any;
}
interface Affiliate {
  AffiliateId: number;
  AffliliateName: string;
}
interface ScholarshipData {
  Scholarshiplist: Scholarship[];
  AffiliateList: Affiliate[];
}
interface TopScholarShipsProps {
  associatedPrograms?: Array<ProgramDetails>;
}

const ScholarshipOffers = ({ associatedPrograms }: TopScholarShipsProps) => {
  const [scholarships, setScholarships] = useState<ScholarshipData | null>(
    null,
  );

  const [showSportsModal, setShowSportsModal] = useState(false);
  const [selectedSport, setSelectedSport] = useState("");
  const [showError, setShowError] = useState(false);

  const modalDispatch = useModalDispatch();
  const fetchScholarships = async () => {
    try {
      const response = await fetch("/api/scholarship");
      const data = await response.json();
      setScholarships(data);
    } catch (error) {
      console.error("Error fetching scholarships:", error);
    }
  };

  const handleApplyNow = (item) => {
    if (item.id === 5) {
      setShowSportsModal(true);
      return;
    }
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalV2,
        modalData: {
          associatedPrograms,
          isLandingPage: true,
          scholarshipProgram: item,
          isScholarShipPage: true,
          heading: "Join India's No. 1 Online University",
          submitBtnText: "Apply Now",
        },
      },
    });
  };

  const handleSportsApply = () => {
    const sportId = selectedSport;
    if (!selectedSport) {
      setShowError(true);
      return;
    }
    window.location.href = `/lp/champ/?ams_id=${sportId}`;
  };

  const scholarshipList = [
    ...(scholarships?.Scholarshiplist.slice(
      0,
      scholarships?.Scholarshiplist.length - 2,
    ) || []),
    {
      category_id: 0,
      description:
        "Applicable for family members of existing Amity Online students and alumni.",
      discount_percentage: "Upto 20",
      id: 6,
      list: null,
      scholarship_name: "Amity Online Family Benefit",
    },
  ];
  const concessionList = scholarships?.Scholarshiplist?.slice(-2);
  const AffiliateList = scholarships?.AffiliateList || [];
  useEffect(() => {
    fetchScholarships();
    StorageService.set("timeConnectModal", true);
  }, []);

  

  return (
    <section className={styles.section} id="scholarship-card">
      <div className={styles.header}>
        <h2 className={styles.title}>
          Top scholarships offered at Amity University Online
        </h2>
        <p className={styles.subtitle}>
          Select the scholarship that aligns with your achievements and
          background
        </p>
      </div>

      <div className={styles.grid}>
        {scholarshipList.map((scholarship, i) => (
          <div key={scholarship.id} className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.cardTop}>
                <div className={styles.iconBox}>
                  <Image
                    src={
                      i === 0
                        ? "https://amityonline.com/_s/offer0_58ab98d8e7.svg"
                        : i === 1
                          ? "https://amityonline.com/_s/offer1_6e13cc4acf.svg"
                          : i === 2
                            ? "https://amityonline.com/_s/offer2_71aa050346.svg"
                            : i === 3
                              ? "https://amityonline.com/_s/offer3_f39b351422.svg"
                              : i === 4
                                ? "https://amityonline.com/_s/offer4_4b93df4436.svg"
                                : i === 5
                                  ? "https://amityonline.com/_s/offer5_dd664a6f09.svg"
                                  : "https://amityonline.com/_s/offer5_dd664a6f09.svg"
                    }
                    alt="Arrow"
                    width={32}
                    height={27}
                  />
                </div>
                <h3 className={styles.cardTitle}>
                  {scholarship.scholarship_name}
                </h3>
              </div>

              <div className={styles.badge}>
                <Image
                  src="https://amityonline.com/_s/Icon_c2db29ebaa.png"
                  alt=""
                  width={20}
                  height={20}
                />
                <span>{scholarship.discount_percentage}% Scholarship</span>
              </div>
            </div>

            <div>
              <p className={styles.eligibilityLabel}>Eligibility Criteria:</p>
              <p className={styles.eligibilityText}>
                {scholarship.description}
              </p>
            </div>
            <button
              className={styles.applyBtn}
              onClick={() => handleApplyNow(scholarship)}
            >
              Apply Now
              <ArrowRight />
            </button>
          </div>
        ))}
      </div>
      {showSportsModal && (
        <div
          className={styles.modalOverlay}
          onClick={() => setShowSportsModal(false)}
        >
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button
              className={styles.modalClose}
              aria-label="Close"
              onClick={() => setShowSportsModal(false)}
            >
              ✕
            </button>

            <h2 className={styles.modalTitle}>Select Sports</h2>

            <div className={styles.modalSelect}>
              <select
                value={selectedSport}
                onChange={(e) => {
                  setSelectedSport(e.target.value);
                  setShowError(false);
                }}
              >
                <option value="" disabled>
                  Sports Name
                </option>
                {AffiliateList.map((sport) => (
                  <option key={sport.AffiliateId} value={sport.AffiliateId}>
                    {sport.AffliliateName}
                  </option>
                ))}
              </select>
              {showError && (
                <p className="text-red-800 text-xs font-bold">
                  Please select any sport to proceed further
                </p>
              )}
            </div>

            <button className={styles.modalApply} onClick={handleSportsApply}>
              Apply Now
              <ArrowRight />
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ScholarshipOffers;
